import { LoaderSreen } from '../../../../../common/components/molecule/Loader/Loader'
import Pagination from '../../../../../common/components/organisme/Pagination/Pagination'
import { OrderByType } from '../../../../../utils/genericAPI/useGenericAPI'
import ErrorScreenApp from '../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp'
import useOrganizations from '../../../hooks/useOrganizations'
import { Organization } from '../../../types/organization.types'
import OrganizationListView from './OrganizationListView/OrganizationListView'
import { useNavigate } from 'react-router-dom'

/**
 * OrganizationListPresenter
 * @returns 
 */
export default function OrganizationListPresenter({pageSize = 10, orderBy = "organization_name"}: {pageSize?: number, orderBy?: OrderByType<Organization>}) {
  const {allOrganizationsQuery} = useOrganizations({
    pageSize: pageSize,
    orderBy: orderBy,
  })
  const navigate = useNavigate()
  if(allOrganizationsQuery.isLoading) {
    return <LoaderSreen heigth="200px" />
  }

  if(allOrganizationsQuery.error) {
    return <ErrorScreenApp axiosError={allOrganizationsQuery.error}/>
  }

  const handleClickRow = (id: string) => {
    navigate(`${id}`)
  }
  const contentFormated = allOrganizationsQuery.data?.data?.map((item) => (
    {
      id: item.organization_id,
      name: item.organization_name,
      city: item.organization_city,
      country: item.organization_country,
      status: item.organization_status,
      onClick: () => handleClickRow(item.organization_id)
    }

  )) || [];

  const pagination = allOrganizationsQuery.data?.pagination

  return (
    <>
    <OrganizationListView  content={contentFormated} nbFound={allOrganizationsQuery.data?.pagination.total_count}/>
    <Pagination currentPage={pagination?.current_page} setCurrentPage={allOrganizationsQuery.setPage} lastPage={pagination?.total_pages} nbBtnToDisplay={5} centered/>
    </>

  )
}
